import React, {memo} from 'react';
import {useFilterSelector} from '../../hooks/filter-selector';
import {ItemList} from '../ItemList';

export const MediaRenderer = memo(function MediaRenderer(props: { type: string; }) {
    const mediaList = useFilterSelector(
        state => state.control.mediaList,
        m => (props.type === 'air' && m.type_id === '1') || (props.type !== 'air' && m.type_id !== '1'),
    );

    return (
        <ItemList medias={mediaList}/>
    );
});
